var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-col',_vm._b({staticClass:"grid-mixed-col"},'b-col',_vm.colOptions,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }